import { render, staticRenderFns } from "./DetachOrgObjectLine.vue?vue&type=template&id=020a6334&scoped=true"
import script from "./DetachOrgObjectLine.vue?vue&type=script&setup=true&lang=js"
export * from "./DetachOrgObjectLine.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetachOrgObjectLine.vue?vue&type=style&index=0&id=020a6334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a6334",
  null
  
)

export default component.exports